import { defineAnimationStyles, defineKeyframes } from '@chakra-ui/react';

export const animationStyles = defineAnimationStyles({
  'menu-open': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      animationName: 'fade-in, slide-from-top',
      animationIterationCount: '1',
    },
  },
  'menu-close': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      animationName: 'fade-out, slide-to-top',
      animationIterationCount: '1',
    },
  },
  'spinner-rotate': {
    value: {
      animationName: 'loader-pulse, rotate',
      animationIterationCount: 'infinite',
    },
  },
  'spinner-pulser-start-rotate': {
    value: {
      animationName: 'loader-pulser-start',
      animationIterationCount: 'infinite',
    },
  },
  'spinner-pulser-end-rotate': {
    value: {
      animationName: 'loader-pulser-end',
      animationIterationCount: 'infinite',
    },
  },
});

export const keyframes = defineKeyframes({
  'fade-in': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  'fade-out': {
    '0%': { opacity: 1 },
    '100%': { opacity: 0 },
  },
  rotate: {
    '0%': { transform: 'rotate(0deg)' },
    '50%': { transform: 'rotate(360deg)' },
    '100%': { transform: 'rotate(720deg)' },
  },
  'loader-pulse': {
    '0%': { '--pulser-start': '0deg', '--pulser-end': '0deg' },
    '50%': { '--pulser-start': '0deg', '--pulser-end': '360deg' },
    '100%': { '--pulser-start': '360deg', '--pulser-end': '360deg' },
  },
  'loader-pulser-start': {
    '0%': { '--pulser-start': '90deg' },
    '50%': { '--pulser-start': '90deg' },
    '100%': { '--pulser-start': '450deg' },
  },
  'loader-pulser-end': {
    '0%': { '--pulser-end': '90deg' },
    '50%': { '--pulser-end': '450deg' },
    '100%': { '--pulser-end': '450deg' },
  },
  'diagonal-shine': {
    '0%': {
      backgroundPosition: '500% 0',
    },
    '100%': {
      backgroundPosition: '-500% 0',
    },
  },
});
